<template>
  <div id="signup-view">
    <div
      class="modal fade bd-example-modal-lg"
      id="signupModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      ref="vuemodal"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body custom-modal-body">
            <vue-custom-scrollbar
              class="scroll-area"
              :settings="settings"
              @ps-scroll-y="scrollHanle"
            >
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="form-title text-center">
                <h4 class="pt-3 mb-0">Sign up</h4>
              </div>
              <div class="d-flex flex-column text-center">
                <form>
                  <b-overlay :show="loader" rounded="sm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="firstname"
                            placeholder="First Name*"
                          />
                          <span class="text-danger" v-if="errors.firstname">{{
                            this.errors.firstname[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="lastname"
                            placeholder="Last Name*"
                          />
                          <span class="text-danger" v-if="errors.lastname">{{
                            this.errors.lastname[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="email"
                            class="form-control"
                            v-model="email"
                            placeholder="Email Address*"
                            disabled
                          />
                          <span class="text-danger" v-if="errors.email">{{
                            this.errors.email[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row">
                          <!-- <div class="col-md-3">
                        <div class="form-group">
                          <vue-country-code
                            defaultCountry="us"
                            @onSelect="onSelect"
                            enabledCountryCode
                            dropdownOptions
                            onlyCountries
                            enabledFlags
                          >
                          </vue-country-code>
                        </div>
                      </div> -->
                          <div class="col-md-12">
                            <div class="form-group">
                              <input
                                type="text"
                                class="form-control"
                                v-model="mobile"
                                placeholder="Mobile*"
                              />
                              <span class="text-danger" v-if="errors.mobile">{{
                                this.errors.mobile[0]
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <select
                            name=""
                            class="form-control"
                            id=""
                            v-model="profession_id"
                            :class="{ 'is-invalid': errors.profession }"
                          >
                            <option value="">--Select Profession--</option>
                            <option
                              v-for="profession in professions"
                              :value="profession.id"
                            >
                              {{ profession.profession_type }}
                            </option>
                          </select>
                          <span
                            class="text-danger"
                            v-if="errors.profession_id"
                            >{{ this.errors.profession_id[0] }}</span
                          >
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="address"
                            placeholder="Address*"
                          />
                          <span class="text-danger" v-if="errors.address">{{
                            this.errors.address[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <select
                            name=""
                            class="form-control"
                            id=""
                            @change="getState(country)"
                            v-model="country"
                            :class="{ 'is-invalid': errors.country }"
                          >
                            <option value="">--Select Country--</option>
                            <option
                              v-for="country in countryData"
                              :value="country"
                            >
                              {{ country.name }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="form-group">
                          <select
                            name=""
                            class="form-control"
                            id=""
                            @change="getCity(state)"
                            v-model="state"
                            :class="{ 'is-invalid': errors.state }"
                          >
                            <option value="">--Select state--</option>
                            <option
                              v-for="state in selectedState"
                              :value="state"
                            >
                              {{ state.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- <div class="col-md-6">
                        <div class="form-group">
                          <select
                            name=""
                            class="form-control"
                            id=""
                            v-model="city"
                            :class="{ 'is-invalid': errors.city }"
                          >
                            <option value="">--Select City--</option>
                            <option v-for="city in selectedCity" :value="city">
                              {{ city.name }}
                            </option>
                          </select>
                        </div>
                      </div> -->
                      <div class="col-md-4">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control"
                            v-model="zip"
                            placeholder="Zip*"
                          />
                          <span class="text-danger" v-if="errors.zip">{{
                            this.errors.zip[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="password"
                            class="form-control"
                            v-model="password"
                            placeholder="Password*"
                          />
                          <span class="text-danger" v-if="errors.password">{{
                            this.errors.password[0]
                          }}</span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="password"
                            class="form-control"
                            v-model="confirm_password"
                            placeholder="Confirm Password*"
                          />
                          <span
                            class="text-danger"
                            v-if="errors.confirm_password"
                            >{{ this.errors.confirm_password[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn btn-secondary col-md-4 btn-round"
                      @click="saveregister()"
                    >
                      Sign up
                    </button>
                  </b-overlay>
                </form>
              </div>
              <div class="signup-section">
                <div class="row d-flex align-items-center">
                  <div class="col-md-12 pt-2 d-flex justify-content-center">
                    <p class="mb-0">
                      Already a member
                      <a type="button" class="text-primary" @click="showForm()"
                        >Login</a
                      >
                    </p>
                  </div>
                  <!-- <div class="col-md-6 d-flex justify-content-end">
                  <button
                    type="button"
                    @click="showForm()"
                    class="btn btn-secondary col-md-6 btn-round"
                  >
                    Login
                  </button>
                </div> -->
                </div>
              </div>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
Vue.use(VueCountryCode);
import countries from "../../../countries.json";
//import states from "../../../states.json";
export default {
  name: "SignupView",
  components: {
    vueCustomScrollbar,
  },
  props: ["socialData", "email"],
  data() {
    return {
      lastname: null,
      firstname: null,
      password: null,
      profession: "",
      profession_id: "",
      professions: [],
      confirm_password: null,
      mobile: null,
      city: "",
      zip: null,
      address: null,
      errors: [],
      login_mode: "Manual",
      unique_id: null,
      countryData: countries,
      stateData: null,
      selectedState: null,
      selectedCity: null,
      cityData: null,
      country_id: "",
      country: "",
      state: "",
      state_id: "",
      city_id: "",
      country_name: "",
      country_code: "",
      state_name: "",
      city_name: "",
      mobile_code: "",
      disabledDialCode: false,
      phone_code: "",
      loader: false,
      enabledFlags: false,
      settings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false,
      },
    };
  },
  created() {
    // console.log(countries);
    // console.log(this.stateData[0]);
    // this.getProfessionsList();
  },
  mounted() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.userData = userData;
    if (this.userData != null) {
      // this.$router.push({ path: '/' });
    } else {
      $(this.$refs.vuemodal).on("show.bs.modal", this.getProfessionsList);
    }
  },
  methods: {
    showForm() {
      this.$emit("ShowLogin", true);
    },
    /* async getState(country) {
      console.log(country);
      var country_id = country.id;
      var country_name = country.name;
      this.country_name = country_name;
      this.mobile_code = country.phone_code;
      var country_code = country.iso2;
      this.country_code = country_code;

      let state = this.stateData;
      this.selectedState = await state.filter(
        (item) => item.country_id == parseInt(country_id)
      );
      console.log(this.selectedState);
    },*/
    getState(country) {
      console.log(country);
      var country_id = country.id;
      var country_name = country.name;
      this.country_name = country_name;
      var country_code = country.iso2;
      this.country_code = country_code;
      this.mobile_code = country.phone_code;

      let apiUrl = process.env.VUE_APP_URL + "customer/state/getState";
      let method_type = "post";

      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          country_id: country_id,
          country_code: country_code,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;

          if (data.status === true) {
            this.selectedState = data.statedata;
          }
        })
        .catch(function(err) {
          // console.log("User Data", "Error : " + err.message, "error");
        });
      // alert(country_id);
    },

    async getCity(state) {
      var state_id = state.id;
      var state_name = state.name;
      this.state_name = state_name;
    },
    getCityName(city) {
      var city_name = city.name;
      this.city_name - city_name;
    },
    onSelect({ dialCode }) {
      this.mobile_code = dialCode;
      console.log(this.mobile_code);
    },
    scrollHanle(evt) {
      console.log(evt);
    },

    //Registration
    saveregister() {
      this.loader = true;

      let apiUrl = process.env.VUE_APP_URL + "customer/customerRegister";
      let method_type = "post";
      let cityName = "";
      if (this.city != undefined) {
        cityName = this.city.name;
      }

      fetch(apiUrl, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: this.password,
          confirm_password: this.confirm_password,
          mobile: this.mobile,
          city: cityName,
          address: this.address,
          zip: this.zip,
          country: this.country_name,
          country_code: this.country_code,
          state: this.state_name,
          unique_id: this.unique_id,
          login_mode: this.login_mode,
          profession_id: this.profession_id,
          mobile_code: this.mobile_code,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          if (data.status === true) {
            this.resetForm();
            var userData = {
              user: data.customer,
              token: data.token,
              status: true,
            };
            localStorage.setItem("userData", JSON.stringify(userData));
            if (process.env.NODE_ENV === "development") {
              window.location.href =
                "http://localhost:8081/account/" +
                data.customer.cross_pltaform_token;
            } else {
              window.location.href =
                "https://account.aixperia.com/account/" +
                data.customer.cross_pltaform_token;
            }
          }
          if (data.status === false) {
            this.loader = false;
            this.errors = data.errors;

            this.$swal("Error", data.message, "error");
          } else {
            this.loader = false;
            this.errors = data.errors;
          }
        })
        .catch(function(err) {
          this.loader = false;

          console.log("Register Data", "Error : " + err.message, "error");
        });
    },
    getProfessionsList() {
      this.errors = [];
      let method_type = "";
      let fetch_url = "";
      method_type = "post";
      fetch_url =
        process.env.VUE_APP_URL + "customer/profession/getAllProfessions";
      fetch(fetch_url, {
        method: method_type,
        headers: {
          "content-type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.loader = false;
          this.errors = [];
          this.professions = data.professions;
        });
    },

    resetForm() {
      this.firstname = null;
      this.lastname = null;
      this.email = null;
      this.password = null;
      this.confirm_password = null;
      this.mobile = null;
      this.address = null;
      this.zip = null;
      this.city = null;
      this.unique_id = null;
      this.login_mode = null;
      this.errors = [];
    },
  },
};
</script>
<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  min-height: 76vh;
  max-height: 85vh;
}
</style>
